import clsx from 'clsx';
import { Link } from '../Link';
import { RightArrowIcon } from '../../assets/icons';

type BreadcrumbItem = {
  label: string;
  url?: string;
};

type BreadcrumbsProps = {
  items?: BreadcrumbItem[];
  title?: string;
  subtitle?: string;
  subtitleUrl?: string;
  className?: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  className,
  title,
  subtitle,
  subtitleUrl,
}) => {
  const breadcrumbItems: BreadcrumbItem[] = items ?? [
    { label: subtitle || '', url: subtitleUrl },
    { label: title || '' },
  ];

  return (
    <div
      className={clsx(
        className,
        'flex flex-wrap items-center gap-x-xs text-medium'
      )}
    >
      {breadcrumbItems.map((item, index) => (
        <div key={index} className="flex items-center">
          {item.url ? (
            <Link
              url={item.url}
              withDecoration
              defaultClassName="text-secondary cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span
              className={clsx(
                'text-maintext font-normal',
                breadcrumbItems.length > 1 &&
                  index === breadcrumbItems.length - 1
                  ? 'font-semibold'
                  : 'font-medium'
              )}
            >
              {item.label}
            </span>
          )}
          {index < breadcrumbItems.length - 1 && (
            <span>
              <RightArrowIcon />
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
